import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';
import { MaterialModule } from '../../material/material.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {  Router } from '@angular/router';
import { RouteEnum } from '../../enums/routes.enum';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-add-to-cart-popup',
  standalone: true,
  imports: [CommonModule, PipesModule, MaterialModule],
  templateUrl: './add-to-cart-popup.component.html',
  styleUrl: './add-to-cart-popup.component.scss'
})
export class AddToCartPopupComponent implements OnInit {

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<AddToCartPopupComponent>,
		private router: Router,
		private authService: AuthService
	) {}

	isLogged : boolean = false;

	ngOnInit(): void {
	}
	
	goBackToCategories(){
		this.isLogged = this.authService.isUserLogged();
		if(this.isLogged){
			this.router.navigate([`/${RouteEnum.EXPLORE}`]);
		} else {
			this.router.navigate([`/${RouteEnum.HOME}`], { queryParams: { courses: true } });
		}
		this.dismiss();
	}

	dismiss() {
		this.dialogRef.close(null);
	}

	goToCart(){
		this.isLogged = this.authService.isUserLogged();
		if(this.isLogged){
			this.router.navigate([`/${RouteEnum.SHOPPING_CART}`, { queryParams: { logged: true }} ]);
		} else {
			this.router.navigate([`${RouteEnum.HOME}/${RouteEnum.SHOPPING_CART}`, { queryParams: { logged: false }} ]);
		}
		this.dismiss();
	}
}
